import { BrandKey } from '../__generated__/queries-web';

type BrandKeyToTitle = {
  [key in keyof typeof BrandKey]?: string;
};

const brandKeyToTitle: BrandKeyToTitle = {
  TEL: 'Télé-Loisirs',
  VOI: 'Voici',
  GAL: 'Gala',
  CAP: 'Capital',
  CAC: 'Cuisine Actuelle',
  FAC: 'Femme Actuelle',
  SHGFAC: 'Shopping Femme Actuelle',
  TLS: 'Télé 2 Semaines',
  TGC: 'Ce soir TV',
  TLA: 'Télé Loisirs Afrique',
  BEA: 'Beauté Addict',
  GEO: 'GEO',
  FRGSL: 'FR Gentside Lifestyle',
  FRGSD: 'FR Gentside Découverte',
  FRGSG: 'FR Gentside Gaming',
  FRGSS: 'FR Gentside Sport',
  FRGSV: 'FR Gentside Voyage',
  FROMM: 'FR Ohmymag',
  BRGTS: 'BR Gentside',
  BROMM: 'BR Ohmymag',
  DEGTS: 'DE Gentside',
  DEOMM: 'DE Ohmymag',
  ESGTS: 'ES Gentside',
  ESOMM: 'ES Ohmymag',
  ITGTS: 'IT Gentside',
  ITOMM: 'IT Ohmymag',
  UKGTS: 'UK Gentside',
  UKOMM: 'UK Ohmymag',
  BIN: 'BUSINES INSIDER',
  CAM: `ça m'interesse`,
  NEO: 'Neon',
  CTR: 'Cine Télé Revue',
  UKSAS: 'UK seandso',
  DESAS: 'DE seandso',
  TESTBRAND: 'Test Brand',
};

export const getTitleFromBrandKey = (brandKey: keyof typeof BrandKey | null) =>
  brandKey && brandKeyToTitle[brandKey] ? brandKeyToTitle[brandKey] : brandKey;

export const ceriseBrandkeys = [
  'FRGSL',
  'FRGSD',
  'FRGSG',
  'FRGSS',
  'FRGSV',
  'FROMM',
  'BRGTS',
  'BROMM',
  'DEGTS',
  'DEOMM',
  'ESGTS',
  'ESOMM',
  'ITGTS',
  'ITOMM',
  'UKGTS',
  'UKOMM',
] as BrandKey[];

export const ceriseBrandkeysDisabled: (keyof typeof BrandKey)[] = [
  'BRGTS',
  'BROMM',
  'ESGTS',
  'ESOMM',
  'ITGTS',
  'ITOMM',
];

export const affiliateAvailableBrandKeys: (keyof typeof BrandKey)[] = [
  'FROMM',
  'FRGSD',
  'FRGSG',
  'FRGSL',
  'FRGSS',
  'FRGSV',
  'CAP',
  'FAC',
  'GEO',
  'SHGFAC',
  'TEL',
];

export const DisplayNewModuleByBrandKeys = [
  BrandKey.BIN,
  BrandKey.CAC,
  BrandKey.CAM,
  BrandKey.CAP,
  BrandKey.FAC,
];

export const DisplayTitleIaByBrandKeys: (keyof typeof BrandKey)[] = [
  'TGC',
  'FRGSD',
  'FRGSG',
  'FRGSL',
  'FRGSS',
  'FRGSV',
  'FROMM',
];
